import { LCDClient } from "@terra-money/terra.js";
import { config } from "../envs/config";

const fetchSortedValidators = async () => {
  let response = await client.wasm.contractQuery(config.addrs.Kyv, {
    get_off_chain_validators: {},
  });
  return response.validator_addresses.sort().reverse();
};

const client = new LCDClient({
  URL: config.env.fcdUrl,
  chainID: config.env.chainId,
});

const fetchSortedTimestamps = async () => {
  let response = await client.wasm.contractQuery(config.addrs.Kyv, {
    get_off_chain_metrics_timestamps: {},
  });
  return response.timestamps.sort().reverse();
};

const kyvOnChain = { fetchSortedTimestamps, fetchSortedValidators };

export default kyvOnChain;
